<h1 mat-dialog-title>Miembros de {{ data.company_product_title }}</h1>

<mat-dialog-content>
  @if (form) {
    <div class="container" [formGroup]="form">
      @for (row of memberRows(); track row.userId) {
        <div class="row">
          <!-- Mostrem usuari -->
          <div class="col-12">
            <img [src]="row.user.profile_picture_url" [alt]="row.user.name + ' ' + row.user.surnames" class="avatar" />
            {{ row.user.name + ' ' + row.user.surnames }}
          </div>
          <!-- Mostrem rows -->
          @for (formGroup of row.members; let i = $index; track formGroup) {
            <div class="col-12 company-product-user-member-row" [formGroup]="formGroup">
              <span class="text">Es</span>
              <mat-form-field appearance="outline" class="nobottom">
                <mat-select formControlName="company_product_user_member_role_id" panelWidth>
                  @for (company_product_user_member_role of company_product_user_member_roles; track company_product_user_member_role) {
                    <mat-option [value]="company_product_user_member_role.id">{{ company_product_user_member_role.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <span class="text">a</span>
              <div class="portion-field-inline">
                <mat-form-field appearance="outline" class="nobottom portion_of_productive_work_day-field">
                  @if (portionDisplayModes[row.userId]?.[i] === 'input') {
                    <input
                      matInput
                      type="number"
                      min="0"
                      max="1"
                      step="0.01"
                      formControlName="portion_of_productive_work_day"
                      (blur)="clampPortionValue(formGroup)"
                      (keydown.enter)="clampPortionValue(formGroup)"
                    />
                  } @else {
                    <mat-select formControlName="portion_of_productive_work_day" panelWidth panelClass="portion-select-panel">
                      <mat-option [value]="0">Sin tiempo</mat-option>
                      <mat-option [value]="0.25">1/4 Jorn.</mat-option>
                      <mat-option [value]="0.5">1/2 Jorn.</mat-option>
                      <mat-option [value]="0.75">3/4 Jorn.</mat-option>
                      <mat-option [value]="1">Jornada Completa</mat-option>
                    </mat-select>
                  }
                </mat-form-field>
                @if (!formGroup.controls['portion_of_productive_work_day'].disabled) {
                  <button
                    mat-icon-button
                    type="button"
                    class="custom-portion-icon-button"
                    matTooltip="Personalizar"
                    (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                    (click)="$event.preventDefault(); $event.stopPropagation(); toggleCustomPortionMode(row.userId, i, formGroup)"
                  >
                    <mat-icon>tune</mat-icon>
                  </button>
                }
              </div>
              <span class="text">con</span>
              <mat-form-field appearance="outline" class="nobottom expected-production-prcnt-field">
                <input
                  matInput
                  type="number"
                  min="0"
                  max="100"
                  step="1"
                  formControlName="expected_production_prcnt"
                  [placeholder]="defaultExpectedProductionPrcntPlaceholderByUserId[row.userId]"
                />
                <span matSuffix>%</span>
              </mat-form-field>
              <span class="text">de prod. con</span>
              <mat-form-field appearance="outline" class="nobottom date">
                <mat-label>Escoge una fecha</mat-label>
                <input
                  matInput
                  [matDatepicker]="pickerStartDate"
                  formControlName="start_date"
                  [matDatepickerFilter]="datepickerFilterStartDate"
                />
                <mat-datepicker-toggle matIconSuffix [for]="pickerStartDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerStartDate></mat-datepicker>
              </mat-form-field>
              <span class="text">hasta</span>
              @if (!formGroup.controls['end_date'].disabled && formGroup.value.end_date === null) {
                <span class="text undefined">
                  indefinido
                  <button mat-icon-button [matTooltip]="'Añadir fecha de finalización'" (click)="addEndDate(formGroup)">
                    <mat-icon>add</mat-icon>
                  </button>
                </span>
              } @else {
                <mat-form-field appearance="outline" class="nobottom date">
                  <mat-label>Escoge una fecha</mat-label>
                  <input
                    matInput
                    [matDatepicker]="pickerEndDate"
                    formControlName="end_date"
                    [matDatepickerFilter]="datepickerFilterEndDate"
                  />
                  <mat-datepicker-toggle matIconSuffix [for]="pickerEndDate"></mat-datepicker-toggle>
                  <mat-datepicker #pickerEndDate></mat-datepicker>
                  @if (formGroup.value['end_date'] !== null && !formGroup.controls['end_date'].disabled && row.members.length - 1 === i) {
                    <button mat-icon-button matIconSuffix (click)="clearEndDate(formGroup)">
                      <mat-icon>clear</mat-icon>
                    </button>
                  }
                </mat-form-field>
              }

              @if (canRemoveMemberRow(formGroup)) {
                <button
                  mat-icon-button
                  color="warn"
                  type="button"
                  [matTooltip]="'Eliminar este tramo'"
                  (click)="removeMemberRow(row.userId, i)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              }
              @if (row.members.length - 1 === i) {
                <button mat-icon-button [matTooltip]="'Añadir cambio de rol'" (click)="addChangeOfRole(row.user.id, formGroup)">
                  <mat-icon>add</mat-icon>
                </button>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (form) {
    @if (workers && partners) {
      <button mat-stroked-button color="accent" (click)="addUser()">
        <mat-icon>add_user</mat-icon>
        Añadir miembro
      </button>
    }
    <button mat-flat-button color="accent" (click)="submit()">Guardar</button>
  }
</mat-dialog-actions>
